import http from '@/utils/http'
import Axios, { AxiosResponse, Method, Canceler, AxiosError } from 'axios'
import { CancelerContainer } from '@/utils/httpCanceler'

export type ApiStatus = 'success' | 'error' | 'fail' | 'cancelled'

export interface ApiResponse<T> {
    status: ApiStatus
    message?: string
    data?: T
    errors?: any
}

export default class HttpApi {
    public static async doRequest<T>(
        method: Method,
        uri: string,
        data?: any,
        params?: any,
        cancelerContainer?: CancelerContainer,
        headers?: any) {
        try {
            const cancelToken = new Axios.CancelToken((c: Canceler) => {
                if (cancelerContainer !== undefined) {
                    cancelerContainer.canceler = c
                }
            })
            const response: AxiosResponse<ApiResponse<T>> = await http.request({
                method,
                url: uri,
                data,
                params,
                cancelToken,
                headers,
            })

            return response.data
        } catch (error) {
            const axiosError = (error as AxiosError).response

            let response: ApiResponse<null> = {
                status: 'fail',
                message: axiosError != null && axiosError.data.message != null ? axiosError.data.message : 'Ops! Isso não deveria estar acontecendo! Tente novamente mais tarde.',
                errors: axiosError != null && axiosError.data.errors != null ? axiosError.data.errors : [],
            }

            if (Axios.isCancel(error)) {
                response = {
                    status: 'cancelled',
                    message: (error as Error).message,
                }
            }
            return response
        }
    }

    public static async get<T>(uri: string, params?: any, cancelerContainer?: CancelerContainer) {
        return await HttpApi.doRequest<T>('GET', uri, null, params, cancelerContainer)
    }
    public static async post<T>(uri: string, data: any, params?: any, cancelerContainer?: CancelerContainer) {
        return await HttpApi.doRequest<T>('POST', uri, data, params, cancelerContainer)
    }
    public static async put<T>(uri: string, data: any, params?: any, cancelerContainer?: CancelerContainer) {
        return await HttpApi.doRequest<T>('PUT', uri, data, params, cancelerContainer)
    }
    public static async delete<T>(
        uri: string,
        params: any,
        cancelerContainer?: CancelerContainer,
        hasData: boolean = true,
    ) {
        const headers = (hasData) ? { 'Content-Type': 'multipart/form-data' } : undefined
        return await HttpApi.doRequest<T>('DELETE', uri, null, params, cancelerContainer, headers)
    }
    public static async upload<T>(uri: string, formData: FormData, cancelerContainer?: CancelerContainer) {
        return await HttpApi.doRequest<T>('POST', uri, formData, null, cancelerContainer, { 'Content-Type': 'multipart/form-data' })
    }
}
